var $fc7b7d43be9703ec$exports = {};
$fc7b7d43be9703ec$exports = {
  "colorInputLabel": function colorInputLabel(args) {
    return "".concat(args.label, ", ").concat(args.channelLabel);
  },
  "colorNameAndValue": function colorNameAndValue(args) {
    return "".concat(args.name, ": ").concat(args.value);
  },
  "colorPicker": "\uC0C9\uC0C1 \uD53C\uCEE4",
  "colorSwatch": "\uC0C9\uC0C1 \uACAC\uBCF8",
  "transparent": "\uD22C\uBA85\uB3C4",
  "twoDimensionalSlider": "2D \uC2AC\uB77C\uC774\uB354"
};
export { $fc7b7d43be9703ec$exports as default };